export const isWebglSupported = () => {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    const canvas = document.createElement('canvas');
    const canvasWebglContext = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    return Boolean(window.WebGLRenderingContext && canvasWebglContext);
  } catch (e) {
    return false;
  }
};
